import React from "react";
import styles from "./mathura-vrindavan-travel-guide.module.css";
import BlogNavigator from "../../../BlogNavigator/BlogNavigator.js";
import PromoSidebar from "../../../PromoSidebar/PromoSidebar";
import CTASection from "../../../../CTASection/CTASection";
import { travelBlogs } from "../TravelCategory.js";
import FAQSection from "../../../../Contact/FAQSection";

import heroimg from "./मेरो वृन्दावन.png";
import foodImg from "./food.png";
import nearbyImg from "./extra.png";
import reachImg from "./How to reach.png";
import itineraryImg from "./itinerary.png";
import bestTimeImg from "./Mathura best time to visit.png";
import festivalImg from "./mathura festivals.png";
import spiritualImg from "./Spiritual exp.png";
import templesImg from "./top temples.png";
import whyVisitImg from "./why visit.png";
 

const mathurafaqData = [
  {
    question: "Where are Mathura and Vrindavan located?",
    answer:
      "Mathura and Vrindavan are twin pilgrimage towns located in Uttar Pradesh, India, about 160 km from Delhi. They are part of the sacred Braj region and are closely associated with the life of Lord Krishna.",
  },
  {
    question: "What is the best time to visit Mathura and Vrindavan?",
    answer:
      "October to March is the best time to visit due to pleasant weather. Major festivals like Janmashtami and Holi attract large crowds, so plan early if visiting during peak celebrations.",
  },
  {
    question: "How can I reach Mathura and Vrindavan?",
    answer:
      "Mathura Junction is well connected by train to Delhi, Agra, and major Indian cities. The nearest airport is in Delhi. Vrindavan is about 15 km from Mathura and can be reached by auto, taxi, or local bus.",
  },
  {
    question: "Which are the must-visit temples in Mathura and Vrindavan?",
    answer:
      "Key temples include Shri Krishna Janmabhoomi Temple in Mathura, Banke Bihari Temple, Prem Mandir, ISKCON Temple, and Radha Raman Temple in Vrindavan. Each temple has unique rituals and aartis.",
  },
  {
    question: "How many days are enough for Mathura and Vrindavan?",
    answer:
      "A 2 to 3-day trip is ideal to comfortably explore major temples, attend aartis, visit ghats like Vishram Ghat, and experience the spiritual atmosphere of Braj.",
  },
  {
    question: "Is it safe for families and senior citizens?",
    answer:
      "Yes, Mathura and Vrindavan are safe for families and elderly travelers. However, during festivals the crowd can be heavy, so plan darshan timings carefully and choose hotels close to temples.",
  },
  {
    question: "What should I wear while visiting temples?",
    answer:
      "Modest and comfortable clothing is recommended. Avoid shorts or sleeveless outfits inside temples. Removing footwear before entering temple premises is mandatory.",
  },
  {
    question: "What are the major festivals celebrated here?",
    answer:
      "Janmashtami, Holi (especially Lathmar Holi in Barsana), Radhashtami, and Kartik month celebrations are major festivals. During these times, the towns are beautifully decorated and spiritually vibrant.",
  },
  {
    question: "Are online darshan or VIP passes available?",
    answer:
      "Some temples provide special darshan queues or festival passes, but most operate on a first-come basis. During peak festivals, it is advisable to arrive early for smooth darshan.",
  },
  {
    question: "What local food should I try in Mathura and Vrindavan?",
    answer:
      "Don’t miss Mathura peda, kachori-sabzi, jalebi, lassi, and sattvik vegetarian thalis. Many eateries serve pure vegetarian food following traditional Braj cuisine.",
  },
  {
    question: "Can I visit nearby places from Mathura?",
    answer:
      "Yes, nearby places include Govardhan Hill for parikrama, Barsana (Radha Rani Temple), Nandgaon, Gokul, and Agra for the Taj Mahal. These can be covered as day trips.",
  },
  {
    question: "Is Mathura–Vrindavan suitable for a spiritual retreat?",
    answer:
      "Yes, the region is ideal for spiritual seekers. Visitors can attend morning and evening aartis, participate in kirtans, do parikrama walks, and experience peaceful temple stays.",
  },
];

const promoOffers = [
  {
    id: 1,
    title: "Divine Braj Yatra Experience",
    desc: "2–3 day guided Mathura & Vrindavan itinerary with VIP darshan assistance, local transfers & curated spiritual experiences.",
    btn: "Enquire Now",
    images: [heroimg],
  },
];

const blogSchema = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": "https://yourdomain.com/blog/mathura-vrindavan-travel-guide"
  },
  headline: "Mathura–Vrindavan Travel Guide",
  description:
    "Complete Mathura Vrindavan travel guide including temples, itinerary, festivals and travel tips.",
  image: "https://yourdomain.com/path-to-hero-image.webp",
  author: {
    "@type": "Organization",
    name: "Atlas Travel House"
  },
  publisher: {
    "@type": "Organization",
    name: "Atlas Travel House",
    logo: {
      "@type": "ImageObject",
      url: "https://yourdomain.com/logo.png"
    }
  },
  datePublished: "2026-03-03",
  dateModified: "2026-03-03",
  about: {
    "@type": "Place",
    name: "Mathura and Vrindavan, Uttar Pradesh, India"
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: mathurafaqData.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};
const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://yourdomain.com",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Travel Blog",
      item: "https://yourdomain.com/blog",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Mathura–Vrindavan Travel Guide",
      item: "https://yourdomain.com/blog/mathura-vrindavan-travel-guide",
    },
  ],
};

  
/* ---------------- MAIN COMPONENT ---------------- */
export default function MathuraVrindavanTravelGuide({
  heroImage,
  sidebar,
  cta,
}) {
  return (
    <article className={styles.page}>
      {/* ================= HERO ================= */}
<header className={styles.heroSection}>        <img
          src={heroimg}
          alt="Mathura Vrindavan"
          className={styles.heroImage}
          loading="eager"
          fetchPriority="high"
        />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Mathura–Vrindavan Travel Guide</h1>
          <p className={styles.heroSubtitle}>
            Birthplace of Lord Krishna • Temples • Festivals • Spiritual Journey
          </p>
        </div>
      </header>

      {/* ================= INTRO ================= */}
      <section className={styles.introSection}>
        <div className={styles.introInner}>
          <h2 className={styles.sectionTitle}>Introduction</h2>
          <p className={styles.introText}>
            Mathura and Vrindavan are not just destinations on the map — they
            are living emotions for millions of devotees and travelers. Believed
            to be the birthplace and playground of Lord Krishna, this sacred
            land of Braj carries stories that are thousands of years old, yet
            feel alive in every chant, temple bell, and narrow lane you walk
            through. From the divine serenity of Yamuna ghats at sunrise to the
            timeless devotion echoing inside ancient temples, Mathura–Vrindavan
            offers a spiritual journey that touches the soul deeply. The air
            here feels different — filled with bhajans, colors of devotion, and
            an unexplainable sense of peace. Whether it’s witnessing the grand
            celebrations of Janmashtami, getting drenched in devotion during the
            legendary Holi of Vrindavan, or simply sitting quietly in a temple
            courtyard, every moment here feels sacred. This travel guide will
            help you explore the true essence of Mathura and Vrindavan — a place
            where faith, culture, and timeless stories come together to create
            an unforgettable experience.
          </p>
        </div>
        </section>

      {/* ================= MAIN CONTENT + SIDEBAR ================= */}
      <section className={styles.bodySection}>
        <div className={styles.bodyGrid}>
          {/* -------- MAIN CONTENT -------- */}
        <div className={styles.mainContent}>
<section id="why-visit" className={styles.contentBlock}>
              <h2 className={styles.sectionTitle}>
                Why Visit Mathura & Vrindavan
              </h2>

              {/* <ImageCarousel images={whyVisitImages} /> */}
<img
  src={whyVisitImg}
  alt="Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Where Lord Krishna was born and lived: </strong>
                  Mathura, the birthplace of Shri Krishna, and Vrindavan, the
                  land of his divine leelas, are not just religious sites — they
                  are sacred chapters of Indian history where mythology, faith,
                  and devotion come alive with every step you take.
                </li>

                <li>
                  <strong>Temples that breathe devotion: </strong>
                  From world-famous temples like Krishna Janmabhoomi, Banke
                  Bihari, and ISKCON Vrindavan to countless hidden shrines, this
                  region is filled with temples that are active centers of
                  worship, not silent monuments.
                </li>

                <li>
                  <strong>
                    Festivals celebrated with unmatched devotion:{" "}
                  </strong>
                  Holi in Vrindavan is not just a festival — it is an emotion.
                  Janmashtami transforms the entire city into a grand
                  celebration of faith, music, lights, and devotion that every
                  traveler should witness at least once.
                </li>

                <li>
                  <strong>Perfect spiritual escape near Delhi & Agra: </strong>
                  Located just a few hours from Delhi, Agra, and Jaipur, Mathura
                  and Vrindavan are ideal for weekend getaways, pilgrimage
                  tours, and cultural travel without long or exhausting
                  journeys.
                </li>
              </ul>
            </section>

<section id="top-temples" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Top Temples & Attractions</h2>


<img
  src={templesImg}
  alt="Top temples in Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Shri Krishna Janmabhoomi, Mathura: </strong>
                  The most sacred site in Mathura, believed to be the exact
                  birthplace of Lord Krishna. Standing here feels deeply
                  emotional — the chants, security, and devotion remind you that
                  this is not just a temple, but the very heart of Krishna’s
                  story.
                </li>

                <li>
                  <strong>Banke Bihari Temple, Vrindavan: </strong>
                  One of the most loved temples in India, known for its unique
                  darshan style. The curtains open and close every few seconds,
                  creating an intense and joyful experience that leaves devotees
                  smiling, emotional, and spiritually overwhelmed.
                </li>

                <li>
                  <strong>ISKCON & Prem Mandir: </strong>
                  ISKCON Vrindavan offers peaceful kirtans and a global
                  spiritual atmosphere, while Prem Mandir mesmerizes visitors
                  with its white marble architecture, illuminated evenings, and
                  beautifully carved scenes from Krishna’s life.
                </li>

                <li>
                  <strong>Nidhivan & Keshi Ghat: </strong>
                  Nidhivan is wrapped in mystery and devotion, believed to be
                  the place of Krishna’s divine raas leela, while Keshi Ghat on
                  the Yamuna offers one of the most serene sunrise and aarti
                  experiences in Vrindavan.
                </li>
              </ul>
            </section>

<section id="spiritual-experiences" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Spiritual Experiences</h2>

<img
  src={spiritualImg}
  alt="Spiritual experiences in Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Yamuna Aarti at Vishram Ghat: </strong>
                  As the sun sets and oil lamps float gently on the Yamuna,
                  Vishram Ghat transforms into a scene of pure devotion. The
                  rhythmic chants, temple bells, and glowing diyas create an
                  atmosphere that instantly calms the mind and connects you to
                  the spiritual soul of Mathura.
                </li>

                <li>
                  <strong>Govardhan Parikrama: </strong>
                  Walking barefoot around the sacred Govardhan Hill is more than
                  a ritual — it is a journey of faith, patience, and surrender.
                  Every step taken during the parikrama feels like a personal
                  conversation with Lord Krishna.
                </li>

                <li>
                  <strong>Morning & Evening Darshan: </strong>
                  Early morning darshan fills the heart with peace, while
                  evening aartis bring energy, music, and devotion together.
                  Each temple offers a different rhythm of spirituality, making
                  every darshan a unique experience.
                </li>

                <li>
                  <strong>Festival Celebrations: </strong>
                  During Holi, Janmashtami, and Radhashtami, Mathura and
                  Vrindavan turn into a living celebration of devotion. Colors,
                  kirtans, and bhajans fill the streets, allowing visitors to
                  experience spirituality in its most joyful and expressive
                  form.
                </li>
              </ul>
            </section>

<section id="best-time" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Best Time to Visit</h2>

<img
  src={bestTimeImg}
  alt="Best time to visit Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>October to March – the most pleasant season: </strong>
                  This is the ideal time to visit Mathura and Vrindavan, with
                  comfortable weather perfect for temple visits, parikramas, and
                  evening aartis. The cooler months allow travelers to explore
                  the sacred streets without exhaustion, making the spiritual
                  experience more peaceful and enjoyable.
                </li>

                <li>
                  <strong>
                    Holi & Janmashtami – for a once-in-a-lifetime
                    experience:{" "}
                  </strong>
                  Visiting during Holi or Janmashtami offers a deep cultural and
                  devotional immersion. The cities come alive with colors,
                  bhajans, and grand celebrations, giving travelers the rare
                  chance to witness Krishna’s festivals where they are
                  celebrated most authentically.
                </li>

                <li>
                  <strong>Summers (April to June) – plan carefully: </strong>
                  Summers in Mathura and Vrindavan can be extremely hot, with
                  temperatures rising sharply during the day. If visiting in
                  this season, early morning and evening darshan, light
                  clothing, and proper hydration are essential.
                </li>
              </ul>
            </section>

<section id="how-to-reach" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>
                How to Reach Mathura & Vrindavan
              </h2>

<img
  src={reachImg}
  alt="How to reach Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>By Road – smooth and scenic connectivity: </strong>
                  Mathura and Vrindavan are well connected by road to major
                  cities like Delhi, Noida, Gurugram, and Agra. Regular buses,
                  taxis, and self-drive routes make road travel convenient,
                  especially for weekend trips and family pilgrimages.
                </li>

                <li>
                  <strong>By Train – the most preferred option: </strong>
                  Mathura Junction is a major railway station with excellent
                  connectivity to Delhi, Mumbai, Kolkata, Chennai, and other
                  Indian cities. From the station, Vrindavan is just a short
                  drive away via local taxis or autos.
                </li>

                <li>
                  <strong>By Air – nearest airports: </strong>
                  The closest airport is Agra, while Delhi International Airport
                  offers the widest range of domestic and international flights.
                  From both airports, Mathura and Vrindavan can be reached
                  easily by road or train.
                </li>
              </ul>
            </section>

<section id="local-food" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Local Food & Prasad</h2>

<img
  src={foodImg}
  alt="Local food of Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Mathura Peda & Rabri: </strong>A visit to Mathura is
                  incomplete without tasting the famous Mathura peda, often
                  offered as prasad in temples. Made with pure milk and
                  devotion, its rich flavor carries the sweetness of Braj’s
                  culture. Rabri, thick and creamy, is another must-try delicacy
                  that melts instantly and leaves a lasting memory.
                </li>

                <li>
                  <strong>Kachori–Sabzi & Jalebi: </strong>
                  The mornings in Mathura and Vrindavan begin with hot kachoris
                  served with spicy sabzi, followed by crisp jalebis dipped in
                  syrup. Simple yet soul-satisfying, this combination is loved
                  by pilgrims and locals alike.
                </li>

                <li>
                  <strong>Braj-style Lassi & Thandai: </strong>
                  Thick, creamy lassi served in earthen cups reflects the true
                  taste of Braj. During festivals and summers, thandai infused
                  with traditional flavors adds a refreshing touch to the
                  spiritual journey.
                </li>
              </ul>
            </section>

<section id="festivals" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Major Festivals & Events</h2>

<img
  src={festivalImg}
  alt="Festivals in Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Janmashtami Celebrations: </strong>
                  Janmashtami in Mathura and Vrindavan is celebrated with
                  unmatched devotion and grandeur. Temples remain beautifully
                  decorated, midnight aartis mark the birth of Lord Krishna, and
                  the entire city stays awake in celebration, making it one of
                  the most spiritually powerful times to visit.
                </li>

                <li>
                  <strong>Holi & Lathmar Holi (Barsana): </strong>
                  Holi here is not just about colors — it is about tradition,
                  devotion, and joy. The world-famous Lathmar Holi of Barsana,
                  where women playfully chase men with sticks, attracts visitors
                  from across the globe and offers a truly unique cultural
                  experience.
                </li>

                <li>
                  <strong>Radha Ashtami & Govardhan Puja: </strong>
                  Radha Ashtami celebrates the divine love of Radha and Krishna,
                  while Govardhan Puja commemorates Krishna lifting the
                  Govardhan Hill. During these festivals, the temples of Braj
                  resonate with kirtans, rituals, and deep spiritual energy.
                </li>
              </ul>
            </section>

<section id="nearby-places" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Nearby Places & Day Trips</h2>

<img
  src={nearbyImg}
  alt="Nearby places to visit from Mathura Vrindavan"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>Barsana & Nandgaon: </strong>
                  Barsana, the birthplace of Radha Rani, and Nandgaon, the home
                  of Krishna’s foster father Nanda Maharaj, are deeply woven
                  into the stories of Braj. These villages offer a peaceful,
                  devotional atmosphere and are especially famous for their
                  temples and vibrant Holi traditions.
                </li>

                <li>
                  <strong>Govardhan Parikrama: </strong>A short trip from
                  Mathura, Govardhan is one of the most sacred sites in Braj.
                  Devotees from all over India come here to perform the
                  parikrama, believing it brings blessings, inner strength, and
                  spiritual fulfillment.
                </li>

                <li>
                  <strong>Gokul & Raman Reti: </strong>
                  Gokul is where Lord Krishna spent his early childhood, while
                  Raman Reti is known for its serene sandy grounds believed to
                  be Krishna’s playground. These places offer calm, reflective
                  experiences away from the busy temple crowds.
                </li>
              </ul>
            </section>

<section id="travel-tips" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>
                Travel Tips & Temple Etiquette
              </h2>
              <ul>
                <li>
                  <strong>Visit temples early in the morning: </strong>
                  Early morning darshan is the most peaceful time in Mathura and
                  Vrindavan. The crowds are lighter, the atmosphere is calmer,
                  and the spiritual energy feels deeply soothing. Morning aartis
                  often leave a lasting impression on first-time visitors.
                </li>

                <li>
                  <strong>Stay alert near ghats and crowded areas: </strong>
                  Popular ghats and temple surroundings can be busy, especially
                  during festivals. Politely avoid unnecessary guides or touts
                  offering paid rituals, and always confirm prices beforehand to
                  ensure a hassle-free experience.
                </li>

                <li>
                  <strong>Dress modestly and respectfully: </strong>
                  As Mathura and Vrindavan are deeply religious destinations,
                  wearing modest clothing is appreciated. Comfortable attire
                  that covers shoulders and knees helps you blend in
                  respectfully and move freely during temple visits and
                  parikramas.
                </li>
              </ul>
            </section>

<section id="itinerary" className={styles.contentBlock}>              <h2 className={styles.sectionTitle}>Suggested 3-Day Itinerary</h2>

<img
  src={itineraryImg}
  alt="Mathura Vrindavan itinerary"
  className={styles.sectionImage}
  loading="lazy"
/>
              <ul>
                <li>
                  <strong>
                    Day 1 – Mathura: Krishna Janmabhoomi & Yamuna Aarti: </strong>
                  Start your journey early in Mathura with darshan at Shri
                  Krishna Janmabhoomi, followed by Dwarkadhish Temple and
                  Vishram Ghat. Spend the afternoon exploring local temples and
                  markets. In the evening, attend the Yamuna Aarti at Vishram
                  Ghat — a deeply calming and spiritually uplifting experience
                  that beautifully begins your Braj journey.
                </li>

                <li>
                  <strong>
                    Day 2 – Vrindavan: Temples, Bhakti & Prem Mandir: </strong>
                  Begin before sunrise with Banke Bihari Temple darshan, then
                  visit ISKCON Vrindavan for peaceful kirtans. Explore Nidhivan
                  and Keshi Ghat, soaking in the divine atmosphere. End your day
                  at Prem Mandir, where the illuminated marble structure and
                  evening light show create a magical and unforgettable sight.
                </li>

                <li>
                  <strong>Day 3 – Barsana, Nandgaon & Govardhan: </strong>
                  On the final day, head to Barsana, the birthplace of Radha
                  Rani, and visit the Radha Rani Temple. Continue to Nandgaon,
                  Krishna’s childhood home, and later proceed to Govardhan for
                  darshan or parikrama. This day offers a quieter, more
                  immersive connection with the true essence of Braj Bhoomi.
                </li>
              </ul>
            </section>
    
            {/* -------- CTA -------- */}
            {cta && <div className={styles.ctaWrap}></div>}
         
          </div>

 <section id="faqs" className={styles.faqBlock}>
   <div className={styles.faqSection}>
    <FAQSection data={mathurafaqData} />
  </div>

  <aside className={styles.promoSection}>
    <PromoSidebar offers={promoOffers} />
  </aside>
</section>
         
        </div>
      </section>
    
      <CTASection
        heading="Ready to Experience the Divine Energy of Mathura & Vrindavan?"
        description="Reading about Braj bhoomi is just the beginning. Feel the devotion, attend the aartis, walk the sacred ghats, and experience Krishna’s land in person."
        buttonText="Plan Your Mathura–Vrindavan Trip"
        buttonLink="tel: +919876543210"
      />

      <BlogNavigator
        category="travel"
        blogs={travelBlogs}
        currentBlogId="mathura-vrindavan-travel-guide"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(blogSchema) }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </article>
  );
}
